import {events, postEvent} from "../../api";

export default {
    state: {
        gtArray: [
            {
                id:"16",
                user_id:23,
                "start":"Mon, 19 Aug 2019 11:00:01 GMT",
                "end":"Tue, 20 Aug 2019 15:00:00 GMT",
                type: 'job'
            },
            {
                id:"7",
                user_id:23,
                "start":"Tue, 20 Aug 2019 15:00:01 GMT",
                "end":"Thu, 22 Aug 2019 5:11:00 GMT",
                type: 'holiday'
            },
        ],

        events: []
    },

    actions: {
        fetchEvents(context) {
            let token = context.getters.getToken.jwt;
            return events({token}).then(r => {
                return context.commit("setEvents", r.data);
            })
        },

        saveEvent(context, data) {
            let token = context.getters.getToken.jwt;
            return postEvent({token, data});
        }
    },

    mutations: {
        setEvents(state, payload) {
            console.log("setEvents payload", payload);
            state.events = payload;
        }
    }
}